import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup, Header, Title } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ProviderIcon } from 'features/calendar_connections/provider_icon';
const iconContainerCss = "icfb6sg";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
export const AuthPopUp = ({
  isOpen,
  onClose
}) => <Popup isOpen={isOpen} onClose={onClose}>
    <Header>
      <IconContainer><ProviderIcon provider="icloud" size="xlarge" /></IconContainer>
      <Title>{I18n.t('publisher.calendar_settings.icloud.two_factor')}</Title>
    </Header>
    <Body>
      <ol>
        <li>
          {' '}
          {I18n.t('publisher.calendar_settings.icloud.sign_into_account')}
        </li>
        <li>{HtmlParser(I18n.t('publisher.calendar_settings.icloud.security_section_html'))}</li>
        <li>{HtmlParser(I18n.t('publisher.calendar_settings.icloud.generate_password_html'))}</li>
      </ol>
    </Body>
    <Footer>
      <Button as="a" href="https://appleid.apple.com/" target="_blank" rel="noopener noreferrer">
        {I18n.t('publisher.calendar_settings.icloud.sign_into_icloud')}
      </Button>
      <Button decoration="secondary-outline" onClick={onClose}>
        {I18n.t('booking.button.close')}
      </Button>
    </Footer>
  </Popup>;

require("./auth_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./auth_popup.js");